export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail или имя пользователя',
      invalidEmailOrUsername: 'Неверный e-mail или имя пользователя',
      invalidPassword: 'Неверный пароль',
      logInToPlanka: 'Вход в Planka',
      noInternetConnection: 'Нет соединения',
      pageNotFound: 'Страница не найдена',
      password: 'Пароль',
      projectManagement: 'Управление проектами',
      serverConnectionFailed: 'Не могу подключиться к серверу',
      unknownError: 'Что-то пошло не так, попробуйте позже',
    },

    action: {
      logIn: 'Войти',
    },
  },
};
